import React from 'react'
import { Pane, Text } from 'evergreen-ui'

const StatusRegister_41 = ({ DataRegister }) => {
  return (
    <>
      <Pane
        hidden={DataRegister[0].REGISTER_ORDER_NUMBER === null}
        color="#8a2846"
        backgroundColor="#ffe5ec"
        height="100%"
        paddingY={4}
        paddingX={5}
        fontSize={14}
        fontFamily=""
        margin={0}
        marginTop={0}
        fontWeight={700}
      >
        ผ่านการคัดเลือกเป็น {DataRegister[0].REGISTER_ORDER}
      </Pane>
      <Pane
        hidden={DataRegister[0].REGISTER_ORDER_NUMBER1 === null}
        color="#8a2846"
        backgroundColor="#ffe5ec"
        height="100%"
        paddingY={4}
        paddingX={5}
        fontSize={14}
        fontFamily=""
        margin={0}
        marginTop={8}
        fontWeight={700}
      >
        ผ่านการคัดเลือกเป็น {DataRegister[0].REGISTER_ORDER1}
      </Pane>
      <Pane display="flex" flexDirection="column" marginTop={8}>
        <Text color="red">หมายเหตุ*</Text>
        {/* <Text fontSize={"12px"}>
          1. ผู้มีสิทธิ์เข้าศึกษา สามารถยืนยันสิทธิ์ และชำระค่าธรรมเนียมการศึกษาได้ตั้งแต่วันที่ 4 ธันวาคม 2568 - 10 ธันวาคม 2568 หากไม่ชำระค่าธรรมเนียมการศึกษาภายในเวลาที่กำหนด จะถือว่าสละสิทธิ์
        </Text> */}
        <Text fontSize={"12px"}>
          1. ผู้ที่ได้รับการคัดเลือกเป็นตัวสำรอง มหาวิทยาลัยฯ จะประกาศผลการคัดเลือก เข้าศึกษาต่อเพิ่มเติมสำหรับทะเบียนสำรอง (ตัวสำรอง) ในวันที่ 30 เมษายน 2569
        </Text>
      </Pane>
    </>

  )
}

export default StatusRegister_41